import { render, staticRenderFns } from "./manage-reseller.vue?vue&type=template&id=3c610715"
import script from "./manage-reseller.vue?vue&type=script&lang=js"
export * from "./manage-reseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports